import { withAuthGate } from '@sunrise-ui/composites';
import InboxConversationView from '@templates/InboxConversationView';
import React from 'react';

function ConnectedScreen() {
  return <InboxConversationView connectionType="connected" />;
}

export default withAuthGate(ConnectedScreen);
